export enum TAB_KEY {
    HOURS = 'hours',
    DAYS_1_4 = '1-4days',
    DAYS_5_PLUS = '5days+',
}

export interface ImageConfig {
    pc: string;
    h5: string;
}

export interface ProductConfig {
    productId: string;
    variantId: string;
    label: string;
    /** 卖点列表，可多条 */
    desc: string[];
    skuTitle?: string;
    link_more?: string;
}

export interface TabDataConfig {
    tabLabel: string;
    label: string;
    title: string;
    desc: string;
    image: ImageConfig;
    products: ProductConfig[];
}

type TranslateFn = (key: string) => string;

/** 从文案读取产品卖点；支持 JSON 数组或换行字符串 */
const getProductDesc = (t: TranslateFn, key: string): string[] => {
    const raw = typeof (t as any).raw === 'function' ? (t as any).raw(key) : t(key);
    if (Array.isArray(raw)) {
        return raw.map((item) => String(item).trim()).filter(Boolean);
    }
    if (typeof raw === 'string' && raw) {
        return raw
            .split('\n')
            .map((item) => item.trim())
            .filter(Boolean);
    }
    return [];
};

const getTabsData = (t: TranslateFn): Record<TAB_KEY, TabDataConfig> => ({
    [TAB_KEY.HOURS]: {
        tabLabel: t('secD_btn1'),
        label: t('label1'),
        title: t('title1'),
        desc: t('desc1'),
        image: {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1785231915836-y1lg37-compressed-Frame%201612708366.webp',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1785232435129-v4qy1t-compressed-Frame%202094655112.webp',
        },
        products: [
            {
                productId: '8435739197638',
                variantId: '44378294452422',
                label: t('i1_product1_label'),
                desc: getProductDesc(t, 'i1_product1_desc'),
                skuTitle: 'EcoFlow DELTA 3 Plus',
                link_more: 'https://au.ecoflow.com/products/ecoflow-delta-3-plus-portable-power-station',
            },
            {
                productId: '8435739197638',
                variantId: '45556169736390',
                label: t('i1_product2_label'),
                desc: getProductDesc(t, 'i1_product2_desc'),
                skuTitle: 'DELTA 3 Plus + 220W Solar Panel',
                link_more: 'https://au.ecoflow.com/products/ecoflow-delta-3-plus-portable-power-station',
            },
        ],
    },
    [TAB_KEY.DAYS_1_4]: {
        tabLabel: t('secD_btn2'),
        label: t('label2'),
        title: t('title2'),
        desc: t('desc2'),
        image: {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1785231924078-7y78s1-compressed-Frame%202094655104.webp',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1785232449199-gr5qvg-compressed-Frame%202094655110.webp',
        },
        products: [
            {
                productId: '8554314727622',
                variantId: '44762205061318',
                label: t('i2_product1_label'),
                desc: getProductDesc(t, 'i2_product1_desc'),
                skuTitle: 'EcoFlow DELTA Pro Ultra Whole-home Backup Battery',
                link_more: 'https://au.ecoflow.com/products/ecoflow-delta-pro-ultra',
            },
            {
                productId: '8311879925958',
                variantId: '44062870503622',
                label: t('i2_product2_label'),
                desc: getProductDesc(t, 'i2_product2_desc'),
                skuTitle: 'EcoFlow DELTA Pro 3',
                link_more: 'https://au.ecoflow.com/products/ecoflow-delta-pro-3-portable-power-station',
            },
        ],
    },
    [TAB_KEY.DAYS_5_PLUS]: {
        tabLabel: t('secD_btn3'),
        label: t('label3'),
        title: t('title3'),
        desc: t('desc3'),
        image: {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1785231931890-edv9k6-compressed-Frame%202094655105.webp',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1785232455215-je69qc-compressed-Frame%202094655111.webp',
        },
        products: [
            {
                productId: '7756526584006',
                variantId: '42673598824646',
                label: t('i3_product1_label'),
                desc: getProductDesc(t, 'i3_product1_desc'),
                skuTitle: 'EcoFlow RIVER 2 Pro',
                link_more: 'https://au.ecoflow.com/products/river-2-pro-portable-power-station',
            },
            {
                productId: '8462188118214',
                variantId: '44457406922950',
                label: t('i3_product2_label'),
                desc: getProductDesc(t, 'i3_product2_desc'),
                skuTitle: 'EcoFlow RIVER 3 Max Plus',
                link_more: 'https://au.ecoflow.com/products/ecoflow-river-3-max-plus-portable-power-station?variant=44457406922950',
            },
        ],
    },
});

export const getTabsConfig = (t: TranslateFn) =>
    Object.entries(getTabsData(t)).map(([key, data]) => ({
        key: key as TAB_KEY,
        ...data,
    }));
